<template>
  <jd-dialog
    :visible.sync="isShowDialog"
    width="45%"
    @close="closeDialog"
    :isShowSure="false"
    :isShowCancel="false"
  >
    <template #title>
      <div>
        <span>AI资源</span>
        <span class="tips">可用于玩法【小红书晒单礼】生成内容</span>
      </div>
    </template>
    <div>
      <div class="flex-box">
        <div class="title-item">
          <div>AI生成文案资源</div>
          <div class="count">{{ statsUsedData.textCount || 0 }}次</div>
        </div>
        <div class="line-box"></div>
        <div class="title-item">
          <div>AI生文使用次数</div>
          <div class="count">{{ statsUsedData.useTextCount || 0 }}次</div>
        </div>
        <div class="line-box"></div>
        <div class="title-item">
          <div>AI生成图片资源</div>
          <div class="count">{{ statsUsedData.imageCount || 0 }}次</div>
        </div>
        <div class="line-box"></div>
        <div class="title-item">
          <div>AI生图使用次数</div>
          <div class="count">{{ statsUsedData.useImageCount || 0 }}次</div>
        </div>
      </div>
      <jd-table
        :tableData="tableData"
        :tableInfo="tableInfo"
        :loading="loading"
        :pageInfo="{
          pageNum: pageInfo.current,
          pageSize: pageInfo.size,
          total: total,
        }"
        @handlePage="handlePageChange"
      >
        <template #addSlot="{ row, rowIndex }">
          <div>
            {{
              row.changeType == 0 ? "使用" : row.changeType == 1 ? "增加" : "-"
            }}
          </div>
        </template>
        <template #modelTypeSlot="{ row, rowIndex }">
          <div>
            {{
              row.modelType == 0
                ? "AI生成文案"
                : row.modelType == 1
                ? "AI生成图片"
                : "-"
            }}
          </div>
        </template>
        <template #changeCountSlot="{ row, rowIndex }">
          <div>{{ (row.changeType == 0 ? "" : "+") + row.changeAmount }}</div>
        </template>
      </jd-table>
    </div>
  </jd-dialog>
</template>
<script>
import { getAiUsageStats, getAiUsageFlow } from "@/api/jhk/aiSkin";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statsUsedData: {
        textCount: 0,
        useTextCount: 0,
        imageCount: 0,
        useImageCount: 0,
      },
      loading: false,
      isShowDialog: false,
      tableData: [],
      tableInfo: [
        {
          prop: "changeTime",
          label: "变更时间",
        },
        {
          prop: "modelType",
          slot: "modelTypeSlot",
          label: "变更类型",
        },
        {
          prop: "useAdd",
          slot: "addSlot",
          label: "使用/增加",
        },
        {
          prop: "changeCount",
          slot: "changeCountSlot",
          label: "变更次数",
        },
        {
          prop: "remainAmount",
          label: "当前剩余次数",
        },
      ],
      pageInfo: {
        size: 10,
        current: 1,
      },
      total: 0,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.isShowDialog = this.isShow;
    this.getStatsUsed();
    this.getList();
  },
  methods: {
    getStatsUsed() {
      getAiUsageStats()
        .then((res) => {
          if (res.code == 1 && res.data) {
            this.statsUsedData = res.data;
          }
        })
        .catch(() => {});
    },
    closeDialog() {
      this.$emit("update:isShow", false);
    },
    getList() {
      this.loading = true;
      getAiUsageFlow(this.pageInfo)
        .then((res) => {
          this.loading = false;
          if (res.code == 1 && res.data) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handlePageChange({ pageNum, pageSize }) {
      this.pageInfo.current = pageNum;
      this.pageInfo.size = pageSize;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.tips {
  margin-left: 16px;
  font-size: 12px;
  color: #333;
}
.flex-box {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.ml20 {
  margin-left: 20px;
}
.title-item {
  font-size: 14px;
  color: #333;
  .count {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
}
.line-box {
  margin: 0 30px;
  width: 1px;
  height: 30px;
  background-color: #999;
}
</style>
